<template>
  <div class="cell-container">
    <img :src="imgPath" alt="">
    <!-- <div class="image">
      <img src="@/assets/ksxg/tixing.png" />
    </div>
    <div class="text">
      <h1>{{ typeData.title }}</h1>
      <span>{{ typeData.des }}</span>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ["typeData","imgPath"]
};
</script>
<style lang="less" scoped>
.cell-container {
  transition: all 0.6s;
  text-align: center;
  width: 1200px;
  border-radius: 2px;
  // border: solid 1px #dedfe1;
  background-color: #ffffff;
  margin: 30px auto;
  // padding: 20px 30px 38px 42px;
  display: flex;
  .image {
    display: inline-block;
    width: 130px;
    background-color: #f7f9fb;
    height: 180px;
    text-align: center;
    img {
      margin-top: 55px;
      // vertical-align:middle;
      // line-height:180px;
      // text-al
      // width: 100%;
      // height: 100%;
      // background-color: #7db7f1;
    }
  }

  .text {
    display: inline-block;
    width: 1000px;
    padding: 20px 30px 38px 42px;
  }
  // margin:
}
</style>
